<template>
  <aside class="site-sidebar" :class="'site-sidebar--' + sidebarLayoutSkin">
    <div class="site-sidebar__inner">
       <el-menu
        :default-active="menuActiveName || 'home'"
        :collapse="sidebarFold"
        :collapseTransition="false"
        router
        class="site-sidebar__menu"
      >
          <el-menu-item index="home" @click="$router.push({ name: 'home' })">
          <i><img src="../assets/images/logo.png" class="indexlog"/></i><br>
          <span slot="title"  class="navtitle navtitle1">昌大建设{{menuActiveName}}</span>
        </el-menu-item>
       </el-menu>
      <el-menu
        :default-active="menuActiveName || 'home'"
        :collapse="sidebarFold"
        :collapseTransition="false"
        router
        class="site-sidebar__menu el-menu-vertical-demo">
 <el-menu-item  v-if="menu.list == null" :index="menu.url != null ? menu.url : ''">
    <i :class="'el-icon navicon '+menu.icon"></i>
    <span slot="title" class="navtitle">{{menu.name}}</span>
  </el-menu-item>  
  
 <el-submenu v-if="menu.list != null" :index='idd+"12"'>
  <template slot="title">
       <i :class="'el-icon navicon '+menu.icon"></i>
      <span slot="title" class="navtitle">{{menu.name}}</span>
    </template>
     <span v-for="(menuerj, id) in menu.list"  :key="id">

    <el-submenu :index='id+"12"' v-if="menuerj.list != null">
     <template slot="title">
       <i :class="'el-icon navicon '+menu.icon"></i>
      <span slot="title" class="navtitle">{{menuerj.name}}</span>
    </template>
      <el-menu-item v-for="(menusanji, ids) in menuerj.list"  :key="ids" :index="menusanji.url">
          <i :class="'el-icon navicon '+menu.icon"></i>
        <span class="navtitle">{{menuerj.name}}</span>
      </el-menu-item>
    </el-submenu>
   <el-menu-item-group v-if="menuerj.list == null">
      <el-menu-item :index="menuerj.url != null ? menuerj.url : ''" :class="$route.path === menuerj.url ? 'is-active' : ''">
         <i :class="'el-icon navicon'+menu.icon"></i>
        <span class="navtitle">{{menuerj.name}}</span></el-menu-item>
    </el-menu-item-group>
     </span>
 
   </el-submenu>


</el-menu>
    
    </div>
  </aside>
</template>

<script>
export default {
  data() {
    return {
      dynamicMenuRoutes: [],
    };
  },
  computed: {
    sidebarLayoutSkin: {
      get() {
        return this.$store.state.common.sidebarLayoutSkin;
      },
    },
    sidebarFold: {
      get() {
        return this.$store.state.common.sidebarFold;
      },
    },
    menuList: {
      get() {
        return this.$store.state.common.menuList;
      },
      set(val) {
        this.$store.commit("common/updateMenuList", val);
      },
    },
    menuActiveName: {
      get() {
        return this.$store.state.common.menuActiveName;
      },
      set(val) {
        this.$store.commit("common/updateMenuActiveName", val);
      },
    },
    mainTabs: {
      get() {
        return this.$store.state.common.mainTabs;
      },
      set(val) {
        this.$store.commit("common/updateMainTabs", val);
      },
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.common.mainTabsActiveName;
      },
      set(val) {
        this.$store.commit("common/updateMainTabsActiveName", val);
      },
    },
  },
  watch: {
    $route: "routeHandle",
  },
  created() {
    this.menuList = JSON.parse(sessionStorage.getItem("menuList") || "[]");
    this.dynamicMenuRoutes = JSON.parse(
      sessionStorage.getItem("dynamicMenuRoutes") || "[]"
    );
    console.log(this.menuList);
    this.routeHandle(this.$route);
  },
  methods: {
    // 路由操作
    routeHandle(route) {
      if (route.meta.isTab) {
        // tab选中, 不存在先添加
        var tab = this.mainTabs.filter((item) => item.name === route.name)[0];
        if (!tab) {
          if (route.meta.isDynamic) {
            route = this.dynamicMenuRoutes.filter(
              (item) => item.name === route.name
            )[0];
            if (!route) {
              return console.error("未能找到可用标签页!");
            }
          }
          tab = {
            menuId: route.meta.menuId || route.name,
            name: route.name,
            title: route.meta.title,
            // type: isURL(route.meta.iframeUrl) ? 'iframe' : 'module',
            iframeUrl: route.meta.iframeUrl || "",
            params: route.params,
            query: route.query,
          };
          this.mainTabs = this.mainTabs.concat(tab);
        }
        this.menuActiveName = tab.menuId + "";
        this.mainTabsActiveName = tab.name;
      }
    },
  },
};
</script>
<style scoped>
.temptitle >>> .el-menu-item-group__title {
  display: none;
}

.navicon{ font-size:36px; }
.navtitle{display: block; padding: 0; line-height:20px ;margin-top: 10px;font-size:16px; font-weight: bold;}
.navtitle1{font-size:19px;color:#f71d2b}
.el-tooltip__popper .navtitle1{font-size:16px;color:#fff}
.site-sidebar__menu .el-menu-item,.site-sidebar__menu>>>.el-submenu__title{ padding: 15px 0 !important;}

.site-sidebar__menu  .el-menu-item>>>.el-tooltip{padding:0 !important;}
</style>
